module.exports = __webpack_public_path__ + "static/francophonie-e5a8d01bd8cc315af56dba5ee34c61a5.jpg";